import SidebarLayout from 'components/Layout/Layout';
import UserAccountList from 'pages/UserManagement/components/UserAccountList';
import { ArrowsLeftRightIcon, CardsThreeIcon, UsersIcon } from '@phosphor-icons/react';
import StatsCard from 'components/ui/StatsCard';
import { useData } from 'components/provider/data';

const UserManagementMainPage = () => {
    const { total_trade, totalAccounts, activeUsers } = useData();

    return (
        <SidebarLayout>
            <div className="space-y-6">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                    <StatsCard
                        title="Tổng người dùng"
                        value={activeUsers}
                        icon={<UsersIcon size={20} color="#fff" />}
                        iconBg="#2563eb"
                    />
                    <StatsCard
                        title="Người dùng hoạt động"
                        value={activeUsers}
                        icon={<UsersIcon size={20} color="#fff" />}
                        iconBg="#16a34a"
                    />
                    <StatsCard
                        title="Tổng tài khoản"
                        value={totalAccounts}
                        icon={<CardsThreeIcon size={20} color="#fff" />}
                        iconBg="#d97706"
                    />
                    <StatsCard
                        title="Tổng giao dịch"
                        value={total_trade}
                        icon={<ArrowsLeftRightIcon size={20} color="#fff" />}
                        iconBg="#7c3aed"
                    />
                </div>
                <UserAccountList />
            </div>
        </SidebarLayout>
    );
};

export default UserManagementMainPage;
